import { z } from 'zod';

/** Ledger-derived tenant wallet snapshot (integer cents). */
export const tenantFinancialSummarySchema = z.object({
  availableCreditCents: z.number().int(),
  outstandingReceivableCents: z.number().int(),
  netSpendableCents: z.number().int(),
});

export type TenantFinancialSummary = z.infer<typeof tenantFinancialSummarySchema>;

/** GET /portal/payments/:id/status polling payload. */
export const portalPaymentStatusSchema = z.object({
  id: z.string(),
  status: z.enum(['Pending', 'Processing', 'Completed', 'Cleared', 'Paid', 'Failed', 'Refunded', 'Cancelled'] as const),
  failureReason: z.string().nullable().optional(),
  updatedAt: z.string().optional(),
});
